import { CONSTANTS } from '../../constants/constants';

const { INFO, USER_VERIFICATION, LATEST_REMEDIATION } = CONSTANTS.TABLE.COLUMN;

/** Columns the column chooser never lists. Shared with the nested SBOM column chooser so both stay in sync. */
export const nonDisableAbleColumns = [INFO, USER_VERIFICATION, LATEST_REMEDIATION];

export const numberFilterOperations = ['equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'];
export const greaterOrEqualLessOrEqualOperations = ['greaterThanOrEqual', 'lessThanOrEqual'];
export const availableFilterOperations = [
  'contains',
  'notContains',
  'startsWith',
  'endsWith',
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
];

export const getFilterOperationCamelCase = filterOpString => {
  return [...availableFilterOperations, ...numberFilterOperations].find(op => op?.toLowerCase() === filterOpString?.toLowerCase());
};

export const createColumnExtensionsMap = columnExtensions => {
  if (!columnExtensions || !Array.isArray(columnExtensions)) return {};

  const map = {};
  columnExtensions.forEach(ext => {
    if (ext.columnName) {
      map[ext.columnName] = ext;
    }
  });

  return map;
};
